<div class="popup-overlay">
  <div class="popup-container">
    <div class="popup-header">
      <div class="progress-bar">
        <div class="progress-step" [class.active]="currentStep >= 1"></div>
        <div class="progress-step" [class.active]="currentStep >= 2"></div>
        <div *ngIf="showSampleDataStep" class="progress-step" [class.active]="currentStep >= 3"></div>
      </div>
      <!-- <button [attr.guide]="'whatapp-integration-popup-btn-1' + '__' + sanitizeUrl(url)" (click)="close()"
        class="logout-btn">
        <mat-icon>close</mat-icon>
      </button> -->
    </div>

    <div class="popup-content">
      <div *ngIf="currentStep === 1" class="step-container">
        <h2>Tell us about your business</h2>
        <form class="business-form" [formGroup]="businessForm">
          <!-- Business name + Website row -->
          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Business name</mat-label>
              <input [attr.guide]="'whatapp-integration-popup-inp-businessname' + '__' + sanitizeUrl(url)" matInput
                formControlName="name" name="businessName" (keydown)="preventLeadingSpace($event)" />
              <mat-error *ngIf="businessForm.get('name')?.invalid && businessForm.get('name')?.touched">
                Please enter your business name.
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Website</mat-label>
              <input [attr.guide]="'whatapp-integration-popup-inp-website' + '__' + sanitizeUrl(url)" matInput
                formControlName="website" name="website" (keydown)="preventAllSpace($event)" />
              <mat-error *ngIf="businessForm.get('website')?.hasError('pattern')">
                Website should not contain spaces.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Phone + Country row -->
          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
            <!-- Dial code -->
            <mat-form-field appearance="outline" style="width: 110px; flex-shrink: 0;">
              <mat-select formControlName="countrycode" (selectionChange)="onCountrySelectionChange($event)"
                [disabled]="isLoadingCountryCode">
                <mat-select-trigger>{{ getCountryCode(businessForm?.get('countrycode')?.value || '75')
                  }}</mat-select-trigger>
                <mat-option>
                  <ngx-mat-select-search placeholderLabel="Search country..."
                    [formControl]="searchControl"></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let country of filteredCountries" [value]="country.id">
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                    <img [src]="country.flag" style="width: 20px; height: 14px; object-fit: cover; border-radius: 2px;">
                    <span style="font-size: 13px;">{{country.name}}</span>
                  </div>
                </mat-option>
              </mat-select>
            </mat-form-field>

             <!-- Phone number -->
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Phone No</mat-label>
              <input [attr.guide]="'whatapp-integration-popup-inp-phoneno' + '__' + sanitizeUrl(url)" numbersOnly
                matInput formControlName="phoneNo" name="phoneNo" type="tel" (keydown)="preventDotAndComma($event)" />

              <mat-error
                *ngIf="businessForm.get('phoneNo')?.hasError('required') && businessForm.get('phoneNo')?.touched">
                Please fill out this field.
              </mat-error>
              <mat-error *ngIf="businessForm.get('phoneNo')?.hasError('customError')">
                Please enter a valid phone number.
              </mat-error>
            </mat-form-field>

            <!-- Location country -->
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Where is your business located?</mat-label>
              <mat-select [attr.guide]="'whatapp-integration-popup-sel-location' + '__' + sanitizeUrl(url)"
                formControlName="location" [disableOptionCentering]="true"
                (selectionChange)="onLocationCountryChange($event)">
                <mat-option>
                  <ngx-mat-select-search ngDefaultControl [formControl]="countrySearchControl"
                    placeholderLabel="Search country..." [preventHomeEndKeyPropagation]="true"
                    noEntriesFoundLabel="No data found">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let opt of filteredLocationCountries" [value]="opt.name">
                  {{opt.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="businessForm.get('location')?.invalid && businessForm.get('location')?.touched">
                Please select a country.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- State + City row (shown after country selected) -->
          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px" *ngIf="selectedCountryId">
            <!-- State: full width alone, 50% alongside city -->
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>State</mat-label>
              <mat-select [attr.guide]="'whatapp-integration-popup-sel-state' + '__' + sanitizeUrl(url)"
                formControlName="state" [disableOptionCentering]="true"
                (selectionChange)="onLocationStateChange($event)"
                [disabled]="!selectedCountryId || locationStates.length === 0">
                <mat-option>
                  <ngx-mat-select-search ngDefaultControl [formControl]="stateSearchControl"
                    placeholderLabel="Search state..." [preventHomeEndKeyPropagation]="true"
                    noEntriesFoundLabel="No data found">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let opt of filteredLocationStates" [value]="opt.name">
                  {{opt.name}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="businessForm.get('state')?.invalid && businessForm.get('state')?.touched">
                Please select your state.
              </mat-error>
            </mat-form-field>

            <!-- City: appears when state is selected -->
            <mat-form-field appearance="outline" fxFlex *ngIf="selectedStateId">
              <mat-label>City</mat-label>
              <mat-select [attr.guide]="'whatapp-integration-popup-sel-city' + '__' + sanitizeUrl(url)"
                formControlName="city" [disableOptionCentering]="true" (selectionChange)="onLocationCityChange($event)"
                [disabled]="!selectedStateId || locationCities.length === 0">
                <mat-option>
                  <ngx-mat-select-search ngDefaultControl [formControl]="citySearchControl"
                    placeholderLabel="Search city..." [preventHomeEndKeyPropagation]="true"
                    noEntriesFoundLabel="No data found">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let opt of filteredLocationCities" [value]="opt.name">
                  {{opt.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Org size + How did you hear — same row -->
          <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
            <div class="form-group" fxFlex>
              <label>How many people are there in your organization? <span class="required">*</span></label>
              <div class="options-group">
                <button [attr.guide]="'whatapp-integration-popup-btn-2' + '__' + sanitizeUrl(url)" type="button"
                  class="option-btn" [class.selected]="businessForm.get('organizationSize')?.value === '1 - 50'"
                  (click)="selectOrgSize('1 - 50')">1 - 50</button>
                <button [attr.guide]="'whatapp-integration-popup-btn-3' + '__' + sanitizeUrl(url)" type="button"
                  class="option-btn" [class.selected]="businessForm.get('organizationSize')?.value === '51 - 200'"
                  (click)="selectOrgSize('51 - 200')">51 - 200</button>
                <button [attr.guide]="'whatapp-integration-popup-btn-4' + '__' + sanitizeUrl(url)" type="button"
                  class="option-btn" [class.selected]="businessForm.get('organizationSize')?.value === '201 - 400'"
                  (click)="selectOrgSize('201 - 400')">201 - 400</button>
                <button [attr.guide]="'whatapp-integration-popup-btn-5' + '__' + sanitizeUrl(url)" type="button"
                  class="option-btn" [class.selected]="businessForm.get('organizationSize')?.value === '500+'"
                  (click)="selectOrgSize('500+')">500+</button>
              </div>
              <div class="error-message"
                *ngIf="businessForm.get('organizationSize')?.invalid && businessForm.get('organizationSize')?.touched">
                Please select your organization size.
              </div>
            </div>

            <div class="form-group" fxFlex>
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>How did you hear about Calsoft?</mat-label>
                <mat-select [attr.guide]="'whatapp-integration-popup-sel-howdidyouhear' + '__' + sanitizeUrl(url)"
                  formControlName="howDidYouHear">
                  <mat-option value="Google">Google</mat-option>
                  <mat-option value="LinkedIn">LinkedIn</mat-option>
                  <mat-option value="Referral">Referral</mat-option>
                  <mat-option value="Facebook">Facebook</mat-option>
                  <mat-option value="Instagram">Instagram</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="businessForm.get('howDidYouHear')?.invalid && businessForm.get('howDidYouHear')?.touched">
                  Please select an option.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </form>
        <div class="popup-footer">
          <button [attr.guide]="'whatapp-integration-popup-btn-6' + '__' + sanitizeUrl(url)" class="next-btn"
            (click)="nextStep()">Next</button>
        </div>
      </div>

      <div *ngIf="currentStep === 2" class="step-container">
        <h2>Let's personalize your homepage ✨</h2>
        <div class="personalize-form" [formGroup]="personalizationForm">
          <div class="form-group">
            <label>Your role <span class="required">*</span></label>
            <div class="options-group wrap">
              <button [attr.guide]="'whatapp-integration-popup-btn-7' + '__' + sanitizeUrl(url)" type="button"
                class="option-btn" [class.selected]="personalizationForm.get('role')?.value === 'Founder'"
                (click)="selectRole('Founder')">Founder</button>
              <button [attr.guide]="'whatapp-integration-popup-btn-8' + '__' + sanitizeUrl(url)" type="button"
                class="option-btn" [class.selected]="personalizationForm.get('role')?.value === 'Marketer'"
                (click)="selectRole('Marketer')">Marketer</button>
              <button [attr.guide]="'whatapp-integration-popup-btn-9' + '__' + sanitizeUrl(url)" type="button"
                class="option-btn"
                [class.selected]="personalizationForm.get('role')?.value === 'Sales / Business Development'"
                (click)="selectRole('Sales / Business Development')">Sales / Business Development</button>
              <button [attr.guide]="'whatapp-integration-popup-btn-10' + '__' + sanitizeUrl(url)" type="button"
                class="option-btn" [class.selected]="personalizationForm.get('role')?.value === 'Customer Support'"
                (click)="selectRole('Customer Support')">Customer Support</button>
              <button [attr.guide]="'whatapp-integration-popup-btn-11' + '__' + sanitizeUrl(url)" type="button"
                class="option-btn"
                [class.selected]="personalizationForm.get('role')?.value === 'Developer/ Product Manager'"
                (click)="selectRole('Developer/ Product Manager')">Developer/ Product Manager</button>
              <button [attr.guide]="'whatapp-integration-popup-btn-12' + '__' + sanitizeUrl(url)" type="button"
                class="option-btn" [class.selected]="personalizationForm.get('role')?.value === 'Others'"
                (click)="selectRole('Others')">Others</button>
            </div>
          </div>
          <div class="form-group">
            <label>Industry <span class="required">*</span></label>
            <div class="card-options-group">
              <div class="option-card" [class.selected]="personalizationForm.get('industry')?.value === 'Education'"
                (click)="selectIndustry('Education')">
                <div class="icon-placeholder">🎓</div>
                <span>Education</span>
              </div>
              <div class="option-card" [class.selected]="personalizationForm.get('industry')?.value === 'Travel'"
                (click)="selectIndustry('Travel')">
                <div class="icon-placeholder">✈️</div>
                <span>Travel</span>
              </div>
              <div class="option-card" [class.selected]="personalizationForm.get('industry')?.value === 'Health Care'"
                (click)="selectIndustry('Health Care')">
                <div class="icon-placeholder">⚕️</div>
                <span>Health Care</span>
              </div>
              <div class="option-card" [class.selected]="personalizationForm.get('industry')?.value === 'Real Estate'"
                (click)="selectIndustry('Real Estate')">
                <div class="icon-placeholder">📄</div>
                <span>Real Estate</span>
              </div>
              <div class="option-card" [class.selected]="personalizationForm.get('industry')?.value === 'Others'"
                (click)="selectIndustry('Others')">
                <div class="icon-placeholder">🎛️</div>
                <span>Others</span>
              </div>
            </div>
          </div>
        </div>
        <div class="popup-footer space-between">
          <button [attr.guide]="'whatapp-integration-popup-btn-13' + '__' + sanitizeUrl(url)" class="previous-btn"
            (click)="previousStep()">Previous</button>
          <button [attr.guide]="'whatapp-integration-popup-btn-14' + '__' + sanitizeUrl(url)" class="next-btn"
            [disabled]="buttonText !== 'Continue'" (click)="nextStep()">
            {{buttonText}}
            <mat-icon *ngIf="buttonText !== 'Continue'">
              <mat-spinner color="primary" diameter="20"></mat-spinner>
            </mat-icon>
          </button>
        </div>
      </div>

      <!-- Step 3: Import Sample Data -->
      <div *ngIf="currentStep === 3 && showSampleDataStep" class="step-container">
        <div class="import-section">
          <h2>Import Sample Data?</h2>
          <p class="import-description">Would you like to import sample CRM data (Leads, Deals, Companies, Activities)
            to explore the system?</p>

          <!-- <div class="form-group">
            <label>Select Modules to Import <span class="required">*</span></label>
            <div class="options-group wrap">
              <button
                *ngFor="let module of availableModules"
                type="button"
                class="option-btn"
                [class.selected]="isModuleSelected(module.key)"
                (click)="toggleModule(module.key)">
                {{ module.label }}
              </button>
            </div>
          </div>
        </div> -->

          <div class="popup-footer space-between">
            <button class="previous-btn" (click)="previousStep()">Previous</button>
            <div class="import-actions">
              <button class="skip-btn" (click)="skipImport()">No, Skip</button>
              <button [attr.guide]="'whatapp-integration-popup-btn-import' + '__' + sanitizeUrl(url)"
                class="next-btn import-btn" [disabled]="importText !== 'Yes, Import Data'" (click)="importSampleData()">
                {{importText}}
                <mat-icon *ngIf="importText !== 'Yes, Import Data'">
                  <mat-spinner color="primary" diameter="20"></mat-spinner>
                </mat-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- <div *ngIf="currentStep === 3" class="step-container connect-step">
        <div class="connect-content">
          <h2>Connect your business number to WhatsApp API</h2>
          <p class="promo-text">Get ₹200 in message credits for free</p>
          <div class="integration-visual">
            <div class="icon-bg"><img src="https://img.icons8.com/color/48/000000/whatsapp--v1.png" alt="WhatsApp" />
            </div>
            <div class="arrows">⇄</div>
            <div class="icon-bg"><img src="https://img.icons8.com/fluency/48/000000/meta.png" alt="Meta" /></div>
          </div>
        </div>
        <div class="phone-preview">
          <img src="https://i.ibb.co/6rC6h5D/whatsapp-preview.png" alt="WhatsApp Preview">
        </div>
        <div class="popup-footer space-between">
          <button [attr.guide]="'whatapp-integration-popup-btn-15' + '__' + sanitizeUrl(url)" class="previous-btn" (click)="previousStep()">Previous</button>
          <button [attr.guide]="'whatapp-integration-popup-btn-16' + '__' + sanitizeUrl(url)" class="next-btn" (click)="nextStep()">Continue</button>
        </div>
      </div>

      <div *ngIf="currentStep === 4" class="step-container">
        <h2>Pre-requisites to connect your phone number with WhatsApp Business API</h2>
        <div class="integration-visual small">
          <div class="icon-bg"><img src="https://img.icons8.com/color/32/000000/facebook-new.png" alt="Facebook" />
          </div>
          <div class="arrows">⇄</div>
          <div class="icon-bg"><img src="https://img.icons8.com/color/32/000000/whatsapp--v1.png" alt="WhatsApp" />
          </div>
          <div class="arrows">⇄</div>
          <div class="icon-bg"><img src="https://img.icons8.com/fluency/32/000000/meta.png" alt="Meta" /></div>
        </div>
        <ul class="prerequisites-list">
          <li>
            <div class="icon-placeholder">📞</div>
            <p>A suitable business phone number to receive the OTP. This <strong>should not</strong> be your personal
              WhatsApp number.</p>
          </li>
          <li>
            <div class="icon-placeholder">🗑️</div>
            <p>If you are currently using WhatsApp with that number, please delete that account. <a>Learn more</a></p>
          </li>
          <li>
            <div class="icon-placeholder">🇫</div>
            <p>Access to Facebook</p>
          </li>
        </ul>
        <div class="prerequisite-check"  [formGroup]="prerequisitesForm">
          <input [attr.guide]="'whatapp-integration-popup-inp-readycheck' + '__' + sanitizeUrl(url)" type="checkbox" id="readyCheck" formControlName="ready" name="readyCheck"/>
          <label for="readyCheck">I am ready with the above pre-requisites</label>
        </div>
        <div class="popup-footer space-between">
          <button [attr.guide]="'whatapp-integration-popup-btn-17' + '__' + sanitizeUrl(url)" class="previous-btn" (click)="previousStep()">Previous</button>
          <button [attr.guide]="'whatapp-integration-popup-btn-18' + '__' + sanitizeUrl(url)" class="next-btn" (click)="confirm()" [disabled]="!prerequisitesForm.valid">Continue</button>
        </div>
      </div> -->
      </div>
    </div>
  </div>